export type NotificationType = {
  id: number;
  type: "primary" | "success" | "error" | "warning";
  variant?: "default" | "light";
  title: string | React.ReactNode;
  message?: string | React.ReactNode;
  priority?: boolean;
  onClose?: () => void;
  timeout?: number | false;
  okText?: string;
  cancelText?: string;
  onOk?: () => void;
  onCancel?: () => void;
};

class NotificationManager {
  listNotify: NotificationType[] = [];

  callback?: (notifications: NotificationType[]) => void;

  create = (
    type: NotificationType["type"],
    notification: Omit<NotificationType, "id" | "type"> | string,
  ) => {
    const notify: NotificationType =
      typeof notification === "string"
        ? {
            title: notification,
            id: new Date().getTime() + Math.random(),
            type,
          }
        : { ...notification, id: new Date().getTime() + Math.random(), type };
    const listNotify = [...this.listNotify];
    if (notify.priority) {
      listNotify.unshift(notify);
    } else {
      listNotify.push(notify);
    }
    this.listNotify = listNotify;
    this.callback?.(listNotify);
    return notify;
  };

  primary = (notification: Omit<NotificationType, "id" | "type"> | string) =>
    this.create("primary", notification);

  success = (notification: Omit<NotificationType, "id" | "type"> | string) =>
    this.create("success", notification);

  warning = (notification: Omit<NotificationType, "id" | "type"> | string) =>
    this.create("warning", notification);

  error = (notification: Omit<NotificationType, "id" | "type"> | string) =>
    this.create("error", notification);

  remove = (notification: NotificationType) => {
    this.listNotify = this.listNotify.filter((n) => notification.id !== n.id);
    this.callback?.(this.listNotify);
    notification.onClose?.();
  };
}

export const notify = new NotificationManager();
